module.exports = __webpack_public_path__ + "static/3-25ef5285c296f655d3210fb0c6a4a328.pdf";